import { AxiosError } from "axios";
import { useGettext } from "vue3-gettext";
import { KnownErrorCodes } from "@/services/aiIdentification";
import type { ErrorCode, ErrorResponse } from "@/services/aiIdentification";

export type AiIdentificationErrorResult = { kind: "loginRequired" } | { kind: "error"; code: ErrorCode; message: string };

export function useAiIdentificationErrorParser() {
  const { $gettext } = useGettext();

  const genericMessage = () => $gettext("Něco se pokazilo a nepodařilo se určit, co je na fotografii. Můžeš to zkusit znovu s jinou fotkou, nebo si zkontroluj správný výběr kategorie.");

  const parseError = (e: unknown): AiIdentificationErrorResult => {
    if (!(e instanceof AxiosError)) {
      throw e;
    }

    const status = e.response?.status;
    if (status === 403) {
      return { kind: "loginRequired" };
    }

    if (status === 406) {
      const error = e.response?.data as ErrorResponse;
      return { kind: "error", code: error.type, message: error.message };
    }

    return { kind: "error", code: KnownErrorCodes.SearchApiError, message: genericMessage() };
  };

  return { parseError };
}
